<template>
  <o-dialog
    ref="dialog"
    :title="$t('general.delete')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.order.actions.deleteItem.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Order } from '~/_api/models/order'

interface Props {
  order: Order
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'update:order', value: Order): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const item = ref<any>(null)

const info = computed(() => {
  return item.value ? item.value.displayLabel : 'Item'
})

const open = (orderItem: any) => {
  item.value = orderItem
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.order.deleteItem(
      props.order.idOrder.toString(),
      item.value.idOrderItem.toString(),
    )

    if (response.data) {
      emit('update:order', response.data)
    }
    emit('update:loading', false)

    $notification.toast({
      title: $i18n.t('components.order.actions.deleteItem.success'),
      text: $i18n.t('components.order.actions.deleteItem.successInfo'),
      variant: 'success',
    })

    return true
  } catch (e: any) {
    console.log(e)
  }

  emit('update:loading', false)
}

defineExpose({ open })
</script>
